import React, { Component } from 'react';
import './App.css';


class ArrowButton extends Component {
  constructor (props) {
    super(props)
    this.state = { 
      //displayDiscuss: false
    }
    
    //this.handleClose=this.handleClose.bind(this)
  }

render() {
 return (
    <div onClick={this.props.buttonCB} className="roundButtonWrapper">
{this.props.btlabel}
<div className="roundButton">
    <svg width={this.props.width} height={this.props.height} viewBox="0 0 31 33" version="1.1">
        <g className="RbSVGFill" id="Artboard" fill="#181818">
            <polygon id="Triangle-2" fillRule="nonzero" points="4.45725291 1.31650406 4.99977834 0.476464686 29.6501314 16.3964844 4.99977834 32.3165041 4.45725291 31.4764647 27.8068998 16.3964844"></polygon>
            <polygon id="Line" fillRule="nonzero" points="29.2285156 15.8964844 29.2285156 16.8964844 0.228515625 16.8964844 0.228515625 15.8964844"></polygon>
        </g>
    </svg>
</div>
</div>

)
}
}

export default ArrowButton;


// WEBPACK FOOTER //
// ./src/ArrowButton.js